<form [formGroup]="cancelPaymentForm">
  <div class="d-flex flex-column p-4">
    <h6 class="text-bold">Cancel Payment</h6>
    <hr />
    <div class="mt-3 table-responsive" style="height: 600px;">
      <table class="table">
        <thead class="bg-light">
          <tr>
            <th>Name</th>
            <th style="min-width: 200px;">Input</th>
            <th style="min-width: 300px;">Expected Result</th>
            <th style="min-width: 200px;">cURL</th>
            <th style="min-width: 200px;">Result</th>
            <th>Note</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of uatPaymentMethod">
            <td class="text-grey col-2" [innerHTML]="row.name || '-'"></td>
            <td class="text-grey col-2 fst-italic w-[200px] min-w-[200px]">
              <pre class="mb-0 whitespace-pre-wrap bg-transparent p-0 border-0 text-[14px]" [innerHTML]="formatJson(row.input) || '-'"></pre>
            </td>
            <td class="text-grey fira-code w-[300px] min-w-[300px] break-words break-all">
              <pre class="mb-0 whitespace-pre-wrap bg-transparent p-0 border-0 text-[14px]" [innerHTML]="formatJson(row.expected_result) || '-'"></pre>
            </td>
            <td class="col-2">
              <textarea rows="8" [formControlName]="'curl_' + row.id" nz-input placeholder="-"></textarea>
            </td>
            <td class="col-2">
              <textarea rows="8" [formControlName]="'result_' + row.id" nz-input placeholder="-"></textarea>
            </td>
            <td class="col-2">{{ row.notes || '-' }}</td>
          </tr>
        </tbody>
      </table>
      <hr>
      <div class="mt-3">
        <span>Validation of Tracking data requires assistance from our team to simulate the delivery, for this can be done by clicking the <a href="https://rajaongkir.com" target="_blank">help button</a> which will be directed to our landing page and please contact via <span style="color: #1890ff;">livechat</span> to get access to tracking simulations.</span>
      </div>
    </div>
    <div class="d-flex align-self-end gap-2 py-3">
      <button class="btn btn-outline-secondary" (click)="previus()">Back</button>
      <button class="btn text-white" [disabled]="cancelPaymentForm.invalid" [ngClass]="{
        'btn-primary': cancelPaymentForm.valid,
        'btn-secondary': !cancelPaymentForm.valid
      }" (click)="next()">Submit</button>
    </div>
  </div>
</form>
